import React, { useState } from 'react';
import { Warehouse, AppTheme } from '../types';

interface WarehouseFormProps {
  theme: AppTheme;
  onSubmit: (data: Omit<Warehouse, 'id' | 'created_at' | 'is_deleted'>) => void;
  onCancel: () => void;
  initialData?: Warehouse;
}

export const WarehouseForm: React.FC<WarehouseFormProps> = ({ theme, onSubmit, onCancel, initialData }) => {
  const [name, setName] = useState(initialData?.name || '');
  const [address, setAddress] = useState(initialData?.address || '');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({ name, address });
  };

  const formStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  };

  const inputGroupStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  };

  const labelStyle: React.CSSProperties = {
    fontSize: '12px',
    color: theme.colors.text,
    fontWeight: 'normal',
  };

  const inputStyle: React.CSSProperties = {
    padding: '6px 8px',
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '2px',
    backgroundColor: theme.colors.background,
    color: theme.colors.text,
    fontSize: '12px',
    fontFamily: 'inherit',
  };

  const buttonGroupStyle: React.CSSProperties = {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
    marginTop: '8px',
  };

  const buttonStyle: React.CSSProperties = {
    padding: '6px 12px',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer',
    fontSize: '11px',
    fontFamily: 'inherit',
  };

  const saveButtonStyle: React.CSSProperties = {
    ...buttonStyle,
    backgroundColor: theme.colors.primary,
    color: 'white',
  };

  const cancelButtonStyle: React.CSSProperties = {
    ...buttonStyle,
    backgroundColor: theme.colors.secondary,
    color: 'white',
  };

  return (
    <form style={formStyle} onSubmit={handleSubmit}>
      <div style={inputGroupStyle}>
        <label style={labelStyle}>Название склада *</label>
        <input
          style={inputStyle}
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          placeholder="Введите название склада"
        />
      </div>

      <div style={inputGroupStyle}>
        <label style={labelStyle}>Адрес *</label>
        <input
          style={inputStyle}
          type="text"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          required
          placeholder="Введите адрес склада"
        />
      </div>

      <div style={buttonGroupStyle}>
        <button type="button" style={cancelButtonStyle} onClick={onCancel}>
          Отмена
        </button>
        <button type="submit" style={saveButtonStyle}>
          Сохранить
        </button>
      </div>
    </form>
  );
};